// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tpl-new-booking-dialog .MuiDialog-paper {
  border-radius: 12px;
  /* height: 600px; */
}

.tpl-dialog-title {
  padding: 20px 24px 16px;
  /* border-bottom: 1px solid #e0e0e0; */
}

.tpl-title-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin: 0 20px;
  gap: 20px;
}

.tpl-title {
  font-weight: 600;
  font-size: 18px;
  margin: 0;
}

.tpl-subtitle {
  color: #666;
  font-size: 13px;
}

.tpl-dialog-content {
  padding: 0 !important;
  overflow: hidden;
}

.tpl-content-wrapper {
  display: grid;
  grid-template-columns: 400px 1fr;
  height: 100%;
  margin: 0 20px;
  gap: 20px;
}

.tpl-left-panel {
  padding: 24px;
  background: #fff;
  border: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  gap: 20px;
  border-radius: 10px;
}

.tpl-right-panel {
  background: #f5f5f6;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  border-radius: 10px;
}
.tpl-right-panel-with-data {
  background: #f5f5f6;
  padding: 24px;
}

.tpl-form-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.tpl-field-label {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.tpl-location-input .MuiOutlinedInput-root {
  border-radius: 20px;
}

.tpl-vehicle-buttons {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  border: none;
}

.tpl-vehicle-button {
  border: 1px solid #d0d0d0 !important;
  border-radius: 8px !important;
  /* padding: 16px 8px !important; */
  text-transform: none !important;
  color: #333 !important;
  background: #fff !important;
  margin: 0 !important;
}

.tpl-vehicle-button.Mui-selected {
  background: #e3f2fd !important;
  border-color: #2196f3 !important;
  color: #2196f3 !important;
}

.tpl-vehicle-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.tpl-vehicle-content svg {
  font-size: 28px;
}

.tpl-vehicle-content span {
  font-size: 12px;
  font-weight: 500;
}

.tpl-schedule-buttons {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  border: none;
}

.tpl-schedule-button {
  border: 1px solid #d0d0d0 !important;
  border-radius: 8px !important;
  padding: 12px !important;
  text-transform: none !important;
  color: #333 !important;
  background: #fff !important;
  margin: 0 !important;
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
}

.tpl-schedule-button.Mui-selected {
  background: #e3f2fd !important;
  border-color: #2196f3 !important;
  color: #2196f3 !important;
}

.tpl-schedule-icon {
  font-size: 18px !important;
}

.tpl-schedule-button span {
  font-size: 13px;
  font-weight: 500;
}

.tpl-find-partners-button {
  background: #2196f3 !important;
  text-transform: none !important;
  padding: 12px !important;
  border-radius: 8px !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  box-shadow: none !important;
  margin-top: auto;
  color: #ffffff !important;
}

.tpl-find-partners-button:hover {
  background: #1976d2 !important;
}

.tpl-waiting-state {
  text-align: center;
  max-width: 300px;
}

.tpl-waiting-icon {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.tpl-cube-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #e0e0e0 0%, #c0c0c0 100%);
  border-radius: 8px;
  opacity: 0.5;
  position: relative;
}

.tpl-cube-icon::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 30px;
  height: 30px;
  border: 3px solid #999;
  border-radius: 4px;
}

.tpl-waiting-title {
  font-weight: 500;
  color: #333;
  margin-bottom: 8px !important;
}

.tpl-waiting-subtitle {
  color: #666;
  line-height: 1.5;
}

.tpl-dialog-footer {
  /* position: absolute;
  bottom: 20px;
  right: 24px; */
  margin: 10px 20px;
  text-align: right;
}

.tpl-book-button {
  background: #2196f3 !important;
  text-transform: none !important;
  padding: 8px 24px !important;
  border-radius: 6px !important;
  font-weight: 500 !important;
  box-shadow: none !important;
  color: #ffffff !important;
}

.tpl-book-button:hover {
  background: #1976d2 !important;
  color: #ffffff !important;
}

.tpl-location-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  padding: 5px 0;
}

.tpl-blue-dot {
  width: 10px;
  height: 10px;
  background: #2563eb;
  border-radius: 50%;
}

.tpl-dashed-line {
  width: 2px;
  height: 70%;
  border-left: 2px dashed #93c5fd;
  margin: 4px 0;
}

.tpl-location-selection-wrapper {
  position: relative;
  margin: 0 0 12px 10px;
}

.tpl-suggestion-list {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 1300;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  margin-top: 4px;
  max-height: 240px;
  overflow-y: auto;
  list-style: none;
  padding: 0;
}

.tpl-suggestion-list li {
  padding: 10px 12px;
  cursor: pointer;
}

.tpl-suggestion-list li:hover {
  background-color: #f1f5f9;
}

.tpl-schedule-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.tpl-schedule-field {
  flex: 1;
  min-width: 0;
}

.tpl-logistics-vehicle-card {
  padding: 10px;
  border-radius: 10px;
  background-color: #ffffff !important;
  margin: 10px 0;
}
.tpl-blue-border-highlight {
  border: 1px solid blue;
}
.tpl-logistics-vehicle-list-container {
  max-height: 350px;
  overflow-y: scroll;
  margin-top: 10px;
}
.tpl-logistics-provider-div {
  padding: 5px 10px;
  background: #0446d2;
  border-radius: 10px;
  font-size: 12px;
  padding: 30px 10px;
  color: #ffffff;
}

/* ════════════════════════════════════════════
   nb___ — NewBooking drawer (Replit design)
   ════════════════════════════════════════════ */

.nb___backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  z-index: 1299;
}

.nb___drawer {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 90%;
  min-width: 600px;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 0 0 0 0;
  box-shadow: -4px 0 40px rgba(15, 23, 42, 0.16);
  z-index: 1300;
  overflow: hidden;
  font-family: inherit;
}

/* ── Header ── */
.nb___header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 20px 24px;
  border-bottom: 1px solid #f1f5f9;
  flex-shrink: 0;
  background: #fff;
}

.nb___header-left {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.nb___back-btn {
  margin-top: 2px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background: #f1f5f9;
  color: #475569;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition:
    background 0.15s,
    color 0.15s;
}
.nb___back-btn:hover {
  background: #e2e8f0;
  color: #0f172a;
}

.nb___title {
  font-size: 1.5rem;
  font-weight: 600;
  letter-spacing: -0.03em;
  color: #020617;
  margin: 0;
  line-height: 1.25;
}

.nb___subtitle {
  font-size: 14px;
  color: #64748b;
  margin: 4px 0 0;
}

.nb___close-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background: transparent;
  color: #64748b;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition:
    background 0.15s,
    color 0.15s;
}
.nb___close-btn:hover {
  background: #f1f5f9;
  color: #0f172a;
}

/* ── Body ── */
.nb___body {
  flex: 1;
  display: grid;
  grid-template-columns: 1.08fr 0.92fr;
  min-height: 0;
  overflow: hidden;
}

.nb___left-panel {
  overflow-y: auto;
  border-right: 1px solid #f1f5f9;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.nb___left-panel::-webkit-scrollbar {
  width: 6px;
}

.nb___left-panel::-webkit-scrollbar-track {
  background: transparent;
}

.nb___left-panel::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.nb___left-panel::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.nb___right-panel {
  background: #f8fafc;
  padding: 20px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

/* ── Location card ── */
.nb___location-card {
  border-radius: 22px;
  border: 1px solid #e2e8f0;
  background: #fff;
  padding: 16px 20px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.nb___loc-inner {
  display: flex;
  align-items: stretch;
  gap: 14px;
}

.nb___loc-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 6px;
  padding-bottom: 6px;
  flex-shrink: 0;
  height: 110px;
}

.nb___dot-filled {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #2a71ff;
  box-shadow: 0 0 0 4px rgba(42, 113, 255, 0.1);
  flex-shrink: 0;
}

.nb___dot-outline {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 3px solid #2a71ff;
  background: #fff;
  box-shadow: 0 0 0 4px rgba(42, 113, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2a71ff;
  flex-shrink: 0;
}

.nb___loc-line {
  flex: 1;
  width: 1px;
  border-left: 1px dashed #bfdbfe;
  margin: 6px 0;
  min-height: 28px;
}

.nb___pick-drop-wrap {
  flex: 1;
  min-width: 0;
}

/* ── Section ── */
.nb___section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.nb___section-title {
  font-size: 16px;
  font-weight: 600;
  color: #0f172a;
}

.nb___field-label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #334155;
  margin-bottom: 8px;
}

.nb___input {
  width: 100%;
  height: 44px;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  padding: 0 12px;
  font-size: 15px;
  color: #0f172a;
  background: #fff;
  transition: border-color 0.15s;
  box-sizing: border-box;
  font-family: inherit;
}
.nb___input:focus {
  outline: none;
  border-color: #94a3b8;
}
.nb___input::placeholder {
  color: #94a3b8;
}

/* hide number input spinners */
.nb___input[type="number"]::-webkit-inner-spin-button,
.nb___input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.nb___input[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;
}

.nb___grid-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.nb___phone-row {
  display: grid;
  grid-template-columns: 80px 1fr;
  gap: 8px;
}

.nb___country-code {
  height: 44px;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  background: #fff;
  font-size: 14px;
  font-weight: 500;
  color: #475569;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: inherit;
}

/* ── Vehicle type ── */
.nb___vehicle-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.nb___vehicle-btn {
  min-height: 86px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #334155;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition:
    border-color 0.15s,
    color 0.15s,
    background 0.15s;
  font-family: inherit;
}
.nb___vehicle-btn:hover:not(.nb___vehicle-btn--active) {
  border-color: #cbd5e1;
}

.nb___vehicle-btn--active {
  border: 1.5px solid #2a71ff;
  background: rgba(42, 113, 255, 0.04);
  color: #155eef;
  box-shadow: 0 10px 22px rgba(42, 113, 255, 0.12);
}

/* ── Schedule ── */
.nb___schedule-row {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.nb___schedule-btn {
  height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 20px;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #475569;
  font-size: 14px;
  font-weight: 500;
  padding: 0 16px;
  cursor: pointer;
  transition:
    border-color 0.15s,
    color 0.15s,
    background 0.15s;
  font-family: inherit;
}
.nb___schedule-btn:hover:not(.nb___schedule-btn--active) {
  border-color: #cbd5e1;
}

.nb___schedule-btn--active {
  border-color: #2a71ff;
  background: rgba(42, 113, 255, 0.04);
  color: #155eef;
}

/* ── Find Partners button ── */
.nb___find-btn {
  height: 48px;
  width: 100%;
  border-radius: 12px;
  background: #1f63ea;
  border: 1px solid transparent;
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 12px;
  box-shadow: 0 14px 30px rgba(31, 99, 234, 0.22);
  transition: background 0.15s;
  font-family: inherit;
}
.nb___find-btn:hover:not(:disabled) {
  background: #155eef;
}
.nb___find-btn:disabled {
  background: #f1f5f9;
  color: #475569;
  border-color: #e2e8f0;
  box-shadow: none;
  cursor: not-allowed;
}

/* ── Right panel — empty state ── */
.nb___empty-state {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 22px;
  border: 1px solid #e2e8f0;
  background: #fff;
  padding: 40px 32px;
  min-height: 360px;
}

.nb___empty-icon {
  color: #94a3b8;
  margin-bottom: 4px;
}

.nb___empty-title {
  font-size: 2rem;
  font-weight: 600;
  letter-spacing: -0.025em;
  color: #1e293b;
  margin: 16px 0 0;
}

.nb___empty-sub {
  font-size: 15px;
  line-height: 1.7;
  color: #64748b;
  margin: 12px 0 0;
  max-width: 280px;
}

/* ── Right panel — with data ── */
.nb___with-data {
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;
}

.nb___loader-center {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nb___partners-title {
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.nb___vehicle-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-y: auto;
}

.nb___vehicle-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  background: #fff;
  padding: 16px 20px;
  cursor: pointer;
  transition: border-color 0.15s;
}
.nb___vehicle-card:hover {
  border-color: #cbd5e1;
}

.nb___vehicle-card--selected {
  border-color: #2a71ff;
  background: rgba(42, 113, 255, 0.02);
}

.nb___vehicle-card-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.nb___provider-badge {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: #eff6ff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  color: #2a71ff;
  flex-shrink: 0;
}

.nb___provider-name {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.nb___provider-eta {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: #64748b;
  margin-top: 3px;
}

.nb___vehicle-cost {
  font-size: 22px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  white-space: nowrap;
}

/* ── Footer ── */
.nb___footer {
  border-top: 1px solid #f1f5f9;
  background: #fff;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-shrink: 0;
}

.nb___footer-hint {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #64748b;
}

.nb___book-btn {
  height: 48px;
  border-radius: 20px;
  background: #1f63ea;
  border: 1px solid transparent;
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  padding: 0 24px;
  cursor: pointer;
  transition: background 0.15s;
  box-shadow: 0 14px 30px rgba(31, 99, 234, 0.22);
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: inherit;
}
.nb___book-btn:hover:not(:disabled) {
  background: #155eef;
}
.nb___book-btn:disabled {
  background: #f1f5f9;
  color: #475569;
  border-color: #e2e8f0;
  box-shadow: none;
  cursor: not-allowed;
}

/* ── Spinner ── */
.nb___spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #e2e8f0;
  border-top-color: #2a71ff;
  border-radius: 50%;
  display: inline-block;
  animation: nb-spin 0.7s linear infinite;
}
.nb___spinner--sm {
  width: 18px;
  height: 18px;
  border-width: 2px;
}
@keyframes nb-spin {
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/ThirdPartyLogistics/components/NewBooking.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,YAAY;EACZ,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,kCAAkC;EAClC,+BAA+B;EAC/B,sBAAsB;EACtB,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,wBAAwB;EACxB,+BAA+B;EAC/B,sBAAsB;EACtB,2BAA2B;EAC3B,oBAAoB;EACpB,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,wBAAwB;EACxB,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;;gBAEc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,4BAA4B;EAC5B,6BAA6B;EAC7B,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;iDAEiD;;AAEjD;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,8CAA8C;EAC9C,aAAa;EACb,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd;;eAEa;AACf;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd;;eAEa;AACf;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,OAAO;EACP,aAAa;EACb,oCAAoC;EACpC,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,6CAA6C;EAC7C,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,6CAA6C;EAC7C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,UAAU;EACV,+BAA+B;EAC/B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,8BAA8B;EAC9B,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;;EAEE,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf;;;oBAGkB;EAClB,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,cAAc;EACd,gDAAgD;AAClD;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf;;;oBAGkB;EAClB,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,+CAA+C;EAC/C,4BAA4B;EAC5B,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,4BAA4B;EAC5B,+CAA+C;EAC/C,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,uCAAuC;AACzC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".tpl-new-booking-dialog .MuiDialog-paper {\n  border-radius: 12px;\n  /* height: 600px; */\n}\n\n.tpl-dialog-title {\n  padding: 20px 24px 16px;\n  /* border-bottom: 1px solid #e0e0e0; */\n}\n\n.tpl-title-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin: 0 20px;\n  gap: 20px;\n}\n\n.tpl-title {\n  font-weight: 600;\n  font-size: 18px;\n  margin: 0;\n}\n\n.tpl-subtitle {\n  color: #666;\n  font-size: 13px;\n}\n\n.tpl-dialog-content {\n  padding: 0 !important;\n  overflow: hidden;\n}\n\n.tpl-content-wrapper {\n  display: grid;\n  grid-template-columns: 400px 1fr;\n  height: 100%;\n  margin: 0 20px;\n  gap: 20px;\n}\n\n.tpl-left-panel {\n  padding: 24px;\n  background: #fff;\n  border: 1px solid #e0e0e0;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  border-radius: 10px;\n}\n\n.tpl-right-panel {\n  background: #f5f5f6;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  border-radius: 10px;\n}\n.tpl-right-panel-with-data {\n  background: #f5f5f6;\n  padding: 24px;\n}\n\n.tpl-form-section {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.tpl-field-label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #333;\n}\n\n.tpl-location-input .MuiOutlinedInput-root {\n  border-radius: 20px;\n}\n\n.tpl-vehicle-buttons {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 8px;\n  border: none;\n}\n\n.tpl-vehicle-button {\n  border: 1px solid #d0d0d0 !important;\n  border-radius: 8px !important;\n  /* padding: 16px 8px !important; */\n  text-transform: none !important;\n  color: #333 !important;\n  background: #fff !important;\n  margin: 0 !important;\n}\n\n.tpl-vehicle-button.Mui-selected {\n  background: #e3f2fd !important;\n  border-color: #2196f3 !important;\n  color: #2196f3 !important;\n}\n\n.tpl-vehicle-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.tpl-vehicle-content svg {\n  font-size: 28px;\n}\n\n.tpl-vehicle-content span {\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.tpl-schedule-buttons {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 8px;\n  border: none;\n}\n\n.tpl-schedule-button {\n  border: 1px solid #d0d0d0 !important;\n  border-radius: 8px !important;\n  padding: 12px !important;\n  text-transform: none !important;\n  color: #333 !important;\n  background: #fff !important;\n  margin: 0 !important;\n  display: flex;\n  gap: 8px;\n  justify-content: center;\n  align-items: center;\n}\n\n.tpl-schedule-button.Mui-selected {\n  background: #e3f2fd !important;\n  border-color: #2196f3 !important;\n  color: #2196f3 !important;\n}\n\n.tpl-schedule-icon {\n  font-size: 18px !important;\n}\n\n.tpl-schedule-button span {\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.tpl-find-partners-button {\n  background: #2196f3 !important;\n  text-transform: none !important;\n  padding: 12px !important;\n  border-radius: 8px !important;\n  font-weight: 500 !important;\n  font-size: 14px !important;\n  box-shadow: none !important;\n  margin-top: auto;\n  color: #ffffff !important;\n}\n\n.tpl-find-partners-button:hover {\n  background: #1976d2 !important;\n}\n\n.tpl-waiting-state {\n  text-align: center;\n  max-width: 300px;\n}\n\n.tpl-waiting-icon {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 20px;\n}\n\n.tpl-cube-icon {\n  width: 60px;\n  height: 60px;\n  background: linear-gradient(135deg, #e0e0e0 0%, #c0c0c0 100%);\n  border-radius: 8px;\n  opacity: 0.5;\n  position: relative;\n}\n\n.tpl-cube-icon::before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 30px;\n  height: 30px;\n  border: 3px solid #999;\n  border-radius: 4px;\n}\n\n.tpl-waiting-title {\n  font-weight: 500;\n  color: #333;\n  margin-bottom: 8px !important;\n}\n\n.tpl-waiting-subtitle {\n  color: #666;\n  line-height: 1.5;\n}\n\n.tpl-dialog-footer {\n  /* position: absolute;\n  bottom: 20px;\n  right: 24px; */\n  margin: 10px 20px;\n  text-align: right;\n}\n\n.tpl-book-button {\n  background: #2196f3 !important;\n  text-transform: none !important;\n  padding: 8px 24px !important;\n  border-radius: 6px !important;\n  font-weight: 500 !important;\n  box-shadow: none !important;\n  color: #ffffff !important;\n}\n\n.tpl-book-button:hover {\n  background: #1976d2 !important;\n  color: #ffffff !important;\n}\n\n.tpl-location-indicator {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 100%;\n  padding: 5px 0;\n}\n\n.tpl-blue-dot {\n  width: 10px;\n  height: 10px;\n  background: #2563eb;\n  border-radius: 50%;\n}\n\n.tpl-dashed-line {\n  width: 2px;\n  height: 70%;\n  border-left: 2px dashed #93c5fd;\n  margin: 4px 0;\n}\n\n.tpl-location-selection-wrapper {\n  position: relative;\n  margin: 0 0 12px 10px;\n}\n\n.tpl-suggestion-list {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  z-index: 1300;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  margin-top: 4px;\n  max-height: 240px;\n  overflow-y: auto;\n  list-style: none;\n  padding: 0;\n}\n\n.tpl-suggestion-list li {\n  padding: 10px 12px;\n  cursor: pointer;\n}\n\n.tpl-suggestion-list li:hover {\n  background-color: #f1f5f9;\n}\n\n.tpl-schedule-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n}\n\n.tpl-schedule-field {\n  flex: 1;\n  min-width: 0;\n}\n\n.tpl-logistics-vehicle-card {\n  padding: 10px;\n  border-radius: 10px;\n  background-color: #ffffff !important;\n  margin: 10px 0;\n}\n.tpl-blue-border-highlight {\n  border: 1px solid blue;\n}\n.tpl-logistics-vehicle-list-container {\n  max-height: 350px;\n  overflow-y: scroll;\n  margin-top: 10px;\n}\n.tpl-logistics-provider-div {\n  padding: 5px 10px;\n  background: #0446d2;\n  border-radius: 10px;\n  font-size: 12px;\n  padding: 30px 10px;\n  color: #ffffff;\n}\n\n/* ════════════════════════════════════════════\n   nb___ — NewBooking drawer (Replit design)\n   ════════════════════════════════════════════ */\n\n.nb___backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.45);\n  z-index: 1299;\n}\n\n.nb___drawer {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 90%;\n  min-width: 600px;\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  border-radius: 0 0 0 0;\n  box-shadow: -4px 0 40px rgba(15, 23, 42, 0.16);\n  z-index: 1300;\n  overflow: hidden;\n  font-family: inherit;\n}\n\n/* ── Header ── */\n.nb___header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 20px 24px;\n  border-bottom: 1px solid #f1f5f9;\n  flex-shrink: 0;\n  background: #fff;\n}\n\n.nb___header-left {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.nb___back-btn {\n  margin-top: 2px;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: none;\n  background: #f1f5f9;\n  color: #475569;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition:\n    background 0.15s,\n    color 0.15s;\n}\n.nb___back-btn:hover {\n  background: #e2e8f0;\n  color: #0f172a;\n}\n\n.nb___title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  letter-spacing: -0.03em;\n  color: #020617;\n  margin: 0;\n  line-height: 1.25;\n}\n\n.nb___subtitle {\n  font-size: 14px;\n  color: #64748b;\n  margin: 4px 0 0;\n}\n\n.nb___close-btn {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: none;\n  background: transparent;\n  color: #64748b;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition:\n    background 0.15s,\n    color 0.15s;\n}\n.nb___close-btn:hover {\n  background: #f1f5f9;\n  color: #0f172a;\n}\n\n/* ── Body ── */\n.nb___body {\n  flex: 1;\n  display: grid;\n  grid-template-columns: 1.08fr 0.92fr;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.nb___left-panel {\n  overflow-y: auto;\n  border-right: 1px solid #f1f5f9;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.nb___left-panel::-webkit-scrollbar {\n  width: 6px;\n}\n\n.nb___left-panel::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.nb___left-panel::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 3px;\n}\n\n.nb___left-panel::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n.nb___right-panel {\n  background: #f8fafc;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n}\n\n/* ── Location card ── */\n.nb___location-card {\n  border-radius: 22px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  padding: 16px 20px;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.nb___loc-inner {\n  display: flex;\n  align-items: stretch;\n  gap: 14px;\n}\n\n.nb___loc-indicator {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-top: 6px;\n  padding-bottom: 6px;\n  flex-shrink: 0;\n  height: 110px;\n}\n\n.nb___dot-filled {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #2a71ff;\n  box-shadow: 0 0 0 4px rgba(42, 113, 255, 0.1);\n  flex-shrink: 0;\n}\n\n.nb___dot-outline {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  border: 3px solid #2a71ff;\n  background: #fff;\n  box-shadow: 0 0 0 4px rgba(42, 113, 255, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #2a71ff;\n  flex-shrink: 0;\n}\n\n.nb___loc-line {\n  flex: 1;\n  width: 1px;\n  border-left: 1px dashed #bfdbfe;\n  margin: 6px 0;\n  min-height: 28px;\n}\n\n.nb___pick-drop-wrap {\n  flex: 1;\n  min-width: 0;\n}\n\n/* ── Section ── */\n.nb___section {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.nb___section-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.nb___field-label {\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  color: #334155;\n  margin-bottom: 8px;\n}\n\n.nb___input {\n  width: 100%;\n  height: 44px;\n  border: 1px solid #e2e8f0;\n  border-radius: 20px;\n  padding: 0 12px;\n  font-size: 15px;\n  color: #0f172a;\n  background: #fff;\n  transition: border-color 0.15s;\n  box-sizing: border-box;\n  font-family: inherit;\n}\n.nb___input:focus {\n  outline: none;\n  border-color: #94a3b8;\n}\n.nb___input::placeholder {\n  color: #94a3b8;\n}\n\n/* hide number input spinners */\n.nb___input[type=\"number\"]::-webkit-inner-spin-button,\n.nb___input[type=\"number\"]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.nb___input[type=\"number\"] {\n  -moz-appearance: textfield;\n  appearance: textfield;\n}\n\n.nb___grid-2 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.nb___phone-row {\n  display: grid;\n  grid-template-columns: 80px 1fr;\n  gap: 8px;\n}\n\n.nb___country-code {\n  height: 44px;\n  border: 1px solid #e2e8f0;\n  border-radius: 20px;\n  background: #fff;\n  font-size: 14px;\n  font-weight: 500;\n  color: #475569;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: inherit;\n}\n\n/* ── Vehicle type ── */\n.nb___vehicle-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n}\n\n.nb___vehicle-btn {\n  min-height: 86px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  border-radius: 16px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  color: #334155;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n  transition:\n    border-color 0.15s,\n    color 0.15s,\n    background 0.15s;\n  font-family: inherit;\n}\n.nb___vehicle-btn:hover:not(.nb___vehicle-btn--active) {\n  border-color: #cbd5e1;\n}\n\n.nb___vehicle-btn--active {\n  border: 1.5px solid #2a71ff;\n  background: rgba(42, 113, 255, 0.04);\n  color: #155eef;\n  box-shadow: 0 10px 22px rgba(42, 113, 255, 0.12);\n}\n\n/* ── Schedule ── */\n.nb___schedule-row {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.nb___schedule-btn {\n  height: 44px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  border-radius: 20px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  color: #475569;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 0 16px;\n  cursor: pointer;\n  transition:\n    border-color 0.15s,\n    color 0.15s,\n    background 0.15s;\n  font-family: inherit;\n}\n.nb___schedule-btn:hover:not(.nb___schedule-btn--active) {\n  border-color: #cbd5e1;\n}\n\n.nb___schedule-btn--active {\n  border-color: #2a71ff;\n  background: rgba(42, 113, 255, 0.04);\n  color: #155eef;\n}\n\n/* ── Find Partners button ── */\n.nb___find-btn {\n  height: 48px;\n  width: 100%;\n  border-radius: 12px;\n  background: #1f63ea;\n  border: 1px solid transparent;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  margin-top: 12px;\n  box-shadow: 0 14px 30px rgba(31, 99, 234, 0.22);\n  transition: background 0.15s;\n  font-family: inherit;\n}\n.nb___find-btn:hover:not(:disabled) {\n  background: #155eef;\n}\n.nb___find-btn:disabled {\n  background: #f1f5f9;\n  color: #475569;\n  border-color: #e2e8f0;\n  box-shadow: none;\n  cursor: not-allowed;\n}\n\n/* ── Right panel — empty state ── */\n.nb___empty-state {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  border-radius: 22px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  padding: 40px 32px;\n  min-height: 360px;\n}\n\n.nb___empty-icon {\n  color: #94a3b8;\n  margin-bottom: 4px;\n}\n\n.nb___empty-title {\n  font-size: 2rem;\n  font-weight: 600;\n  letter-spacing: -0.025em;\n  color: #1e293b;\n  margin: 16px 0 0;\n}\n\n.nb___empty-sub {\n  font-size: 15px;\n  line-height: 1.7;\n  color: #64748b;\n  margin: 12px 0 0;\n  max-width: 280px;\n}\n\n/* ── Right panel — with data ── */\n.nb___with-data {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  height: 100%;\n}\n\n.nb___loader-center {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.nb___partners-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n}\n\n.nb___vehicle-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  overflow-y: auto;\n}\n\n.nb___vehicle-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  background: #fff;\n  padding: 16px 20px;\n  cursor: pointer;\n  transition: border-color 0.15s;\n}\n.nb___vehicle-card:hover {\n  border-color: #cbd5e1;\n}\n\n.nb___vehicle-card--selected {\n  border-color: #2a71ff;\n  background: rgba(42, 113, 255, 0.02);\n}\n\n.nb___vehicle-card-left {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n.nb___provider-badge {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  background: #eff6ff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 700;\n  color: #2a71ff;\n  flex-shrink: 0;\n}\n\n.nb___provider-name {\n  font-size: 15px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n}\n\n.nb___provider-eta {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 13px;\n  color: #64748b;\n  margin-top: 3px;\n}\n\n.nb___vehicle-cost {\n  font-size: 22px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n  white-space: nowrap;\n}\n\n/* ── Footer ── */\n.nb___footer {\n  border-top: 1px solid #f1f5f9;\n  background: #fff;\n  padding: 16px 24px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-shrink: 0;\n}\n\n.nb___footer-hint {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  color: #64748b;\n}\n\n.nb___book-btn {\n  height: 48px;\n  border-radius: 20px;\n  background: #1f63ea;\n  border: 1px solid transparent;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 500;\n  padding: 0 24px;\n  cursor: pointer;\n  transition: background 0.15s;\n  box-shadow: 0 14px 30px rgba(31, 99, 234, 0.22);\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-family: inherit;\n}\n.nb___book-btn:hover:not(:disabled) {\n  background: #155eef;\n}\n.nb___book-btn:disabled {\n  background: #f1f5f9;\n  color: #475569;\n  border-color: #e2e8f0;\n  box-shadow: none;\n  cursor: not-allowed;\n}\n\n/* ── Spinner ── */\n.nb___spinner {\n  width: 32px;\n  height: 32px;\n  border: 3px solid #e2e8f0;\n  border-top-color: #2a71ff;\n  border-radius: 50%;\n  display: inline-block;\n  animation: nb-spin 0.7s linear infinite;\n}\n.nb___spinner--sm {\n  width: 18px;\n  height: 18px;\n  border-width: 2px;\n}\n@keyframes nb-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
